import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { CATALOG_BOOKSET_LIST_SET_DATA } from 'rebook/apps/catalog/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import pluralize from 'rebook/apps/utils/text/pluralize';


export function fetchInitialData(rubricId = null, location = {}) {
  return async(dispatch, getState) => {
    const { ssr, booksetList } = getState();
    const { rubricInfo } = booksetList;
    let getParams = get(location, 'search', null);
    getParams = queryString.parse(getParams);
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;

    let newState = {
      ...booksetList,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    const curentRubricId = get(rubricInfo, 'id', null);
    const newRubricId = get(getParams, 'rubric', null);

    if (!newState.rubricInfo) {
      await dispatch(setData({ rubricInfo: null }));
    }
    if (newState.rubricInfo && rubricId) {
      await dispatch(setData({ rubricInfo: newState.rubricInfo }));
    }
    if (!newState.booksets || newState.pageNumber !== pageNumber || !rubricId || curentRubricId !== newRubricId) {
      await dispatch(fetchBooksets(pageNumber, rubricId));
    }
    if (!newState.rubricInfo || (rubricId || curentRubricId !== newRubricId)) {
      await dispatch(fetchRubric(rubricId));
    }
  };
}

export function fetchRubric(rubricId) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/rubrics/${rubricId}/`;

    if (!rubricId) {
      dispatch(setData({ rubricInfo: null }));
      return null;
    }

    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({ rubricInfo: data }));
      })
      .catch(({ data, resp, error }) => {
        Raven.captureMessage('failed to load rubric info due to server error', {
          level: 'error',
          extra: {
            status: resp.status,
            response: data,
            error,
          },
        });
        dispatch(setData({ rubricInfo: null }));
        return null;
      });
  };
}

export function fetchBooksets(pageNumber = 1, rubricId = null) {
  return async(dispatch, getState) => {
    const { ssr, booksetList } = getState();

    const prevPageNumber = pageNumber && pageNumber - 1;
    let queryParams = {
      booklimit: 10,
      limit: booksetList.paginateBy,
    };

    if (prevPageNumber) {
      queryParams.offset = booksetList.paginateBy * prevPageNumber;
    }
    if (rubricId) {
      queryParams.rubrics = rubricId;
    }

    const qs = queryString.stringify(queryParams);
    const url = `/api/booksets/?${qs}`;

    const pendingState = {
      booksets: null,
      pageNumber,
    };
    dispatch(setData(pendingState));

    const booksets = await (
      fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
        .then(({ data }) => {
          return data;
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load bookset list for book due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          return [];
        })
    );
    const lastPageNumber = Math.ceil(booksets.meta.total_count / booksetList.paginateBy);
    dispatch(
      setData({
        booksets: booksets.objects,
        pageNumber, lastPageNumber,
        totalBookSets: booksets.meta.total_count,
      }));
  };
}

export function setSeoMeta(pageNumber, rubric) {
  return (dispatch, getState) => {
    const { booksetList } = getState();
    const canonicalUrl = `https://${BASE_HOST}/sets/`;
    let title = `Тематические списки и подборки книг от редакции.`;
    let description = 'Тематические списки и подборки книг самых разных жанров от редакции сайта MyBook. ' +
                      'От бизнес-книг и книг по психологии до эзотерики и юмористической литературы.';
    if (rubric && rubric.name) {
      title = `Что почитать по теме «${rubric.name}» - лучшие подборки на MyBook.`;
      description = `Что почитать по теме «${rubric.name}» - ${booksetList.totalBookSets}`
        + ` ${pluralize(booksetList.totalBookSets, 'лучшая подборка', 'лучшие подборки', 'лучших подборок')},`
        + 'рейтинг читателей и отзывы на MyBook.';
    }

    dispatch(SeoActions.setData({
      canonicalUrl,
      title,
      description,
      pageNumber,
    }));
  };
}

export function setData(payload) {
  return (dispatch, getState) => {
    const { booksetList } = getState();
    dispatch({
      type: CATALOG_BOOKSET_LIST_SET_DATA,
      payload,
    });
    if (payload.rubricInfo || payload.booksets) {
      dispatch(setSeoMeta(booksetList.pageNumber, payload.rubricInfo));
    }
  };
};
